import { CSSProperties } from 'react';

import { LogEntry } from './types';
import { SeverityPill } from './SeverityPill';
import { formatTimeLocal } from './utils';

interface Props {
  log: LogEntry;
  style?: CSSProperties;
  onSelect: (log: LogEntry) => void;
}

export function LogTableRow({ log, style, onSelect }: Props) {
  const { time, source, severity, message } = log;
  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={`View details for log at ${formatTimeLocal(time)}`}
      style={style}
      className="grid cursor-pointer grid-cols-[200px_140px_100px_1fr] items-center gap-x-3 border-b border-gray-3 px-4 py-1.5 text-xs hover:bg-gray-2 th-highcontrast:border-gray-6 th-highcontrast:hover:bg-gray-10 th-dark:border-gray-8 th-dark:hover:bg-gray-9"
      onClick={() => onSelect(log)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(log);
        }
      }}
    >
      <div className="truncate text-gray-7 th-highcontrast:text-gray-4 th-dark:text-gray-4">
        {formatTimeLocal(time)}
      </div>
      <div className="min-w-0 truncate text-blue-8 th-highcontrast:text-blue-3 th-dark:text-blue-4">
        {source}
      </div>
      <div className="min-w-0">
        {severity && <SeverityPill severity={severity} />}
      </div>
      <div className="truncate font-mono">{message}</div>
    </div>
  );
}
